import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EnvironmentService } from '../environment.service';
import { IGridService } from '../models/igrid-service';
import { LieuDebarquementDto } from '@lexi-clients/lexi';
import { LieuDebarquementListResult } from '../models/lieu-debarquement-list';

@Injectable({
  providedIn: 'root'
})
export class LieuDebarquementListService implements IGridService<LieuDebarquementDto> {
  baseUrl: string;

  constructor(private http: HttpClient, envService: EnvironmentService) {
    this.baseUrl = envService.environment.baseServiceUrl;
  }

  get(params: HttpParams): Observable<LieuDebarquementListResult> {
    return this.http.get<any>(`${this.baseUrl}/api/LieuDebarquement/recherche-devexpress`, { params: params });
  }

  getById(lieuDebarquementId: number): Observable<LieuDebarquementDto> {
    return this.http.get<any>(`${this.baseUrl}/api/LieuDebarquement/${lieuDebarquementId}`);
  }

  post(valeur: LieuDebarquementDto): Observable<any> {
    return null;
  }

  put(valeur: LieuDebarquementDto): Observable<any> {
    return null;
  }

  delete(valeur: LieuDebarquementDto): Observable<any> {
    return null;
  }
}
